module.exports = "<option value=\"{{value}}\" :selected=\"{{selected}}\" index=\"{{index}}\"><content></content></option>";
